import * as React from 'react';
import MessagePreviewFull from './components/MessagePreviewFull';
import discardMessagePreviewOption from './actions/discardMessagePreviewOption';
import saveMessagePreviewOption, { onMessagePreviewToggle, } from './actions/saveMessagePreviewOption';
import isMessagePreviewOptionDirty from './utils/isMessagePreviewOptionDirty';
import isMessagePreviewEnabled from './utils/isMessagePreviewEnabled';
var MessagePreviewOption = {
    key: 'messagePreview',
    titleStringKey: 'optionTitle_messagePreview',
    searchTermsStringKey: 'optionTitle_messagePreview',
    fullOptionFormSettings: {
        render: function () { return React.createElement(MessagePreviewFull, null); },
        isDirty: isMessagePreviewOptionDirty,
        onSave: saveMessagePreviewOption,
        onDiscard: discardMessagePreviewOption,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: isMessagePreviewEnabled,
            onToggle: onMessagePreviewToggle,
        },
        order: 8 /* PreviewText */,
        workloads: 1 /* Mail */,
    },
};
export default MessagePreviewOption;
//# sourceMappingURL=MessagePreviewOption.js.map